import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="layout-bottom, margin, padding" maskId="round-filled-radius-1-stroke-1.5-IconLayoutBottom"><path d="M21 15.25C21 16.2165 20.2165 17 19.25 17H4.75C3.7835 17 3 16.2165 3 15.25V4.75C3 3.7835 3.7835 3 4.75 3H19.25C20.2165 3 21 3.7835 21 4.75V15.25Z" fill="currentColor"/><path d="M21 20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25C3 19.8358 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.8358 21 20.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutBottom;
